export enum enumUserType {
    None = 0,
    Admin = 1,
    Worker = 2,
    Dealer = 3
};